const dashboards = [
  {
    valor:"Otro",
    
    url:"https://public.tableau.com/views/NavegacindeServiciosdeSaludenbasealCIE-10pormesdelperiodo2011a2021sinembarazos/Dashboard1"
    },
  {
    valor:"Embarazo, parto y puerperio",
    
    url:"https://public.tableau.com/views/NavegacindeServiciosdeSaludenbasealCIE-10pormesdelperiodo2011a2021embarazos/Dashboard1"
  }

  
];

export default dashboards;
